export default function authorizationSuccess(authorizationData) {
    return {
        type: authorizationSuccess.type,
        payload: authorizationData,
    };
}

authorizationSuccess.type = 'AUTHORIZATION_SUCCESS';
